module.exports = __webpack_public_path__ + "static/img/qdhf3.9eee2b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/qdhf3.jpg
// module id = rT21
// module chunks = 0